import { ROUTE_PATH, QUARTER_OPTIONS, YEAR_OPTIONS } from "common/constants/sm-constants";
import { FormMetaModel, SmBtnMetaModel, SmMetaFileModel, SmMetaSelectModel } from "common/models/utility-models/meta-model";

export class MentoringDocumentMetaModel extends FormMetaModel {
    constructor() {
        super('Add Mentoring Document Details', ROUTE_PATH.mentoringDocument, ROUTE_PATH.addMentoringDocument, 3, '', false, '', '', 'row align-items-start');
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const quarter_number = new SmMetaSelectModel(
            'quarter_number',
            'quarter_number',
            'select',
            true,
            'col-sm-6 col-xs-12 col-md-6 col-lg-6',
            1,
            3,
            'Select Quarter',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            QUARTER_OPTIONS,
            'name',
            'id',
        );
        const year_number = new SmMetaSelectModel(
            'year_number',
            'year_number',
            'select',
            true,
            'col-sm-6 col-xs-12 col-md-6 col-lg-6',
            1,
            3,
            'Select Year',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            YEAR_OPTIONS,
            'name',
            'id'
        );

        const mentoringDoc = new SmMetaFileModel(
            'mentoringDoc',
            'mentoringDoc',
            'file',
            true,
            'input-fg form-group col-6 col-md-6',
            2,
            4,
            'Upload Mentoring Document (Only pdf, excel, image and word files allowed)',
            'PDF',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            ['pdf', 'xls', 'xlsx', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'svg', 'webp'],
            3000,
            250,
            510,
            'mentoringDoc',
            'display_filename',
            false,
            false,
            2000,
            3000
        )


        const buttons = {
            submit: new SmBtnMetaModel('Submit', '', true, false, true, true),
            isFormControl: false
        };


        return {
            formInfo,
            buttons,
            quarter_number,
            year_number,
            mentoringDoc

        }
    }
}
